import { cva, VariantProps } from 'class-variance-authority'

export type TabsStyling = VariantProps<typeof tabsStyling>

export const tabsStyling = cva('flex gap-stack-dense max-w-fit overflow-x-auto', {
  variants: {
    variant: {
      pill: 'rounded-pill p-stack-dense bg-surface-muted',
      plain: '',
    },
  },
  defaultVariants: {
    variant: 'pill',
  },
})
